
<template>
	<form ref="form" :action="action" :method="method" @submit.prevent="onSubmit">
		<!-- <div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="country_address">{{ t('country') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="country_address" name="country_address" class="input text-primary placeholder-secondary-200" v-model="country_address" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('country_address') }" type="text">
					<p v-show="errors.has('country_address')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('country_address') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{country}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="city_address">{{ t('city') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="city_address" name="city_address" class="input text-primary placeholder-secondary-200" v-model="city_address" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('city_address') }" type="text">
					<p v-show="errors.has('city_address')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('city_address') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{city}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="area_address">{{ t('area') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="area_address" name="area_address" class="input text-primary placeholder-secondary-200" v-model="area_address" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('area_address') }" type="text">
					<p v-show="errors.has('area_address')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('area_address') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{area}}</p>
				</div>
			</div>
		</div>
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="house_address">{{ t('house') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="house_address" name="house_address" class="input text-primary placeholder-secondary-200" v-model="house_address" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('house_address') }" type="text">
					<p v-show="errors.has('house_address')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('house_address') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{house}}</p>
				</div>
			</div>
		</div> -->
		<div class="md:flex md:items-center mb-6">
			<div class="md:w-1/5">
				<label class="block text-gray-500 font-bold" for="orderAddress">{{ t('orderAddress') }}</label>
			</div>
			<div class="md:w-4/5">
				<div v-if="edit">
					<input ref="shipping_address" name="shipping_address" class="input text-primary placeholder-secondary-200" v-model="shipping_address" v-validate="{ required: true , min:3 ,max:255 }" :class="{'border-red-500': errors.has('shipping_address') }" type="text">
					<p v-show="errors.has('shipping_address')" class="text-red-500 text-sm mt-3 text-center">{{ errors.first('shipping_address') }}</p>
				</div>
				<div v-else>
					<p class="text-black">{{shippingAddress}}</p>
				</div>
			</div>
		</div>
		<div class="flex">
			<div class="w-1/2 m-auto mt-8 text-center" v-if="edit">
				<button type="submit" class="inline-block button bg-secondary-200 hover:bg-blue-700 text-white">
					{{ t('confirm') }}
				</button>
			</div>
			<div :class="{'w-1/2 m-auto mt-8 text-center':edit , 'w-full m-auto text-center mt-8':!edit} ">
				<a href="#" class="inline-block button  text-white" :class="{'bg-secondary-200 hover:bg-blue-700' : !edit , 'bg-gray-600 hover:bg-gray-500' : edit}" @click="editFun()">
					{{edit == false ? t('edit'): t('cancel')}}
				</a>
			</div>
		</div>
	</form>
</template>
<script>

	import axios from 'axios';
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator , mapFields} from 'vee-validate';
	import trans from './translation/user.json';
	export default {
		name: 'user-address',
		props: {
			method: {
				type: String,
				required: true
			},
			action: {
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
			shippingAddress:{
				type: String,
				required: true
			},
			country:{
				type: String,
				required: true
			},
			city:{
				type: String,
				required: true
			},
			area:{
				type: String,
				required: true
			},
			house:{
				type: String,
				required: true
			}

		},
		data: () => ({
			submitting: false,
			success: false,
			shipping_address: '',
			country_address :'',
			city_address :'',
			area_address :'',
			house_address :'',
			edit:false,
		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		locales: trans,
		created() {
			this.shipping_address= this.shippingAddress;
			this.country_address= this.country;
			this.city_address= this.city;
			this.area_address= this.area;
			this.house_address= this.house;
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
				custom:trans.ar.custom
			});
			this.$validator.localize('en', {
				custom:trans.en.custom
			});
			
			Validator.localize(this.sitelocale);
			console.log(this.action);
		},
		methods: {
			editFun(){
				this.edit = !this.edit
				if(this.edit == false){
					this.shipping_address = this.shippingAddress;
				}
			},
			onSubmit(){
				this.$validator.validateAll().then((result) => {
					if (result) {			
						this.submitting = true;
						const action = this.action;
						axios.post(action, {shipping_address : this.shipping_address})
						.then(response => {
							this.$toasted.success(response.data.success);
							this.success = true;
							setTimeout(function() {
								window.location.reload();
							}, 1000);
						})
						.catch(error => {
							let toaster = this.$toasted;
							$.each(error.response.data.errors, function(key, value) {
								toaster.error(value.message);
							});
							this.success = false;
						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});
					}
				});
			},
		},
	};
</script>
<style type="text/css">
.hidden{
	display: none;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/UserAddress.vue